import { makeStyles } from 'tss-react/mui';

const SEPARATOR_OFFSET = 6;

export const useObjectDetailsSlotStyles = makeStyles()((theme) => {
  const toggleDuration = theme.transitions.duration.shorter;

  return {
    separator: {
      transform: `translateX(${SEPARATOR_OFFSET}px)`,
      '& + [data-panel]': {
        transition: `flex-grow ${toggleDuration}ms ${theme.transitions.easing.easeInOut}, visibility 0s`,
      },
      '&[data-separator="active"] + [data-panel], &[data-separator="focus"] + [data-panel]': {
        transition: 'none',
      },
    },
    separatorClosed: {
      '& + [data-panel]': {
        flexGrow: '0 !important',
        visibility: 'hidden',
        transitionDelay: `0s, ${toggleDuration}ms`,
      },
    },
  };
});
